import { WorkspaceMember } from '@futrli-sdk/people';

import { AccessControlResourceResponseWithEntityType } from '../../../predict/src/core/api/sharing';
import { getUserName } from '../../utils/users/getUserName';

export interface AccessControlResourceResponseWithOwnerName extends AccessControlResourceResponseWithEntityType {
  readonly owner_name?: string;
}

export const processResourcePermissions = (
  resourcePermissions: AccessControlResourceResponseWithEntityType,
  members: WorkspaceMember[]
): AccessControlResourceResponseWithOwnerName => {
  const owner = members.find(member => member.id === resourcePermissions.owner_id);
  const owner_name = owner ? getUserName(owner.name) : undefined;

  return {
    ...resourcePermissions,
    owner_name
  };
};
